import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Form } from 'antd';

const FormItem = Form.Item;

const FormCheckbox = ({ name, disabled, children, extraProps }) => {
  return (
    <FormItem name={name} valuePropName="checked" style={{ marginTop: '-16px' }}>
      <Checkbox disabled={disabled} {...extraProps}>
        {children}
      </Checkbox>
    </FormItem>
  );
};

FormCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  extraProps: PropTypes.object
};

FormCheckbox.defaultProps = {
  name: '',
  extraProps: {}
};

export default FormCheckbox;
